import {
  TextField,
  TextFieldProps,
  Box,
  BoxProps,
  FormControl,
  Select,
  SelectProps,
  FormControlProps,
  SelectChangeEvent,
  Typography,
  TypographyProps,
} from "@/common/styles/style";
import { ReactNode } from "react";

interface TextDataInputProps {
  boxProps?: BoxProps;
  textProps?: TextFieldProps;
  formControlProps?: FormControlProps;
  typographyProps?: TypographyProps;
  selectProps?: SelectProps;
  label: string | ReactNode;
  datatype: string;
  children?: ReactNode;
  value?: string;
  onChange?: (value: string) => void;
}

export default function DataInput({
  boxProps,
  textProps,
  formControlProps,
  typographyProps,
  selectProps,
  label,
  datatype,
  children,
  value,
  onChange,
}: TextDataInputProps) {
  return (
    <Box {...boxProps}>
      <FormControl fullWidth {...formControlProps}>
        <Typography variant="h6" {...typographyProps}>{label}</Typography>
        {datatype === "TextField" ? (
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            {...textProps}
            onChange={onChange ? (e) => onChange(e.target.value) : undefined}
          />
        ) : (
          <Select
            size="small"
            value={value}
            {...selectProps}
            onChange={(e: SelectChangeEvent<unknown>) => {
              const newValue = e.target.value as string;
              onChange?.(newValue);
            }}
          >
            {children}
          </Select>
        )}
      </FormControl>
    </Box>
  );
}
